export const settings = {
    title: "ব্যবসার সেটিংস",
    description: "আপনার ব্যবসার প্রোফাইল, ইনভয়েস, অঞ্চল ও বিক্রির নিয়ম।",
    readOnly: "আপনি সেটিংস দেখতে পারবেন। শুধু মালিক বা অ্যাডমিন পরিবর্তন করতে পারবেন।",
    sections: {
        profile: "ব্যবসার প্রোফাইল",
        invoices: "ইনভয়েস ও রসিদ",
        region: "অঞ্চল",
        sales: "বিক্রির নিয়ম",
    },
    name: "ব্যবসার নাম",
    logo: "লোগো",
    noLogo: "এখনো লোগো নেই",
    uploadLogo: "লোগো আপলোড করুন",
    removeLogo: "লোগো সরান",
    uploading: "আপলোড হচ্ছে…",
    logoFailed: "লোগোটি ব্যবহার করা যায়নি। JPEG, PNG বা WebP ছবি আপলোড করুন।",
    address: "ঠিকানা",
    phone: "ফোন",
    phoneHint: "বাংলাদেশি মোবাইল নম্বর, যেমন ০১৭১২-৩৪৫৬৭৮",
    bin: "বিআইএন (ভ্যাট নিবন্ধন)",
    binHint: "১৩ সংখ্যা",
    invoiceFooter: "ইনভয়েসের নিচের লেখা",
    customerLocale: "গ্রাহকদের জন্য ভাষা",
    customerLocaleHint: "গ্রাহকদের রসিদ, ইনভয়েস ও এসএমএসে ব্যবহার হবে।",
    timezone: "টাইম জোন",
    taxMode: "দাম ও ভ্যাট",
    taxModes: { inclusive: "দামের মধ্যে ভ্যাট আছে", exclusive: "দামের সাথে ভ্যাট যোগ হবে" },
    discountLimit: "অনুমোদন ছাড়া ছাড়ের সীমা (%)",
    discountLimitHint: "সীমিত ছাড়ের অনুমতি থাকা কর্মীদের এর বেশি ছাড়ে ম্যানেজারের অনুমোদন লাগবে।",
    refundLimit: "অনুমোদন ছাড়া রিফান্ডের সীমা (৳)",
    refundLimitHint: "সীমিত রিফান্ডের অনুমতি থাকা কর্মীদের এর বেশি রিফান্ডে ম্যানেজারের অনুমোদন লাগবে।",
    saved: "সেটিংস সংরক্ষণ হয়েছে।",
    conflict: "অন্য কেউ এই সেটিংস পরিবর্তন করেছেন। সর্বশেষ তথ্য দেখানো হচ্ছে; আবার পরিবর্তন করুন।",
};
//# sourceMappingURL=settings.js.map